import { AbstractComponentPropTypes } from '../../../cms/registries';
import { ImageDefination } from '../../types/common';
import { ThemeColorType } from '../../../utils/themeColor';
import { VideoSectionProps } from '../../VideoSection/VideoSection';

export interface Images {
  imageList: ImageDefination[];
}

export interface ShopNow {
  text: string;
  url: string;
  target?: string;
}

export interface VideoModalData {
  videoSection: VideoSectionProps;
}

interface VideoBannerProps extends AbstractComponentPropTypes {
  brandLogo: ImageDefination[];
  brandTagLine: string;
  overlayGradient?: GradientType;
  linearGradient?: ThemeColorType;
  watchVideoText?: string;
  shopNow: ShopNow;
  backgroundVideoUrl: string;
  videoModalData: VideoModalData;
}

export interface VideoModalProps {
  onClose: () => void;
  videoSection: VideoSectionProps;
}

type GradientType = keyof typeof Gradient;

enum Gradient {
  darkgreen = 'darkgreenGradient',
  blue = 'blueGradient',
  orange = 'orangeGradient',
  gray = 'grayGradient',
  red = 'redGradient',
}

export default VideoBannerProps;
export { Gradient, GradientType };
